export default __webpack_public_path__ + "static/media/icon-personal-finances.cdda9f82.svg";